import { AnalyticsEvent } from './BaseAnalyticsEvent';
import { type AnalyticsEventName } from './types/AnalyticsEventName';

export class RetainEvent extends AnalyticsEvent<AnalyticsEventName.RETAIN_CLICK> {
  constructor(public data: { chapterId: string }) {
    super('analytics.retain_click');
  }
}
